/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-column-totalDocsInserted[_ngcontent-%COMP%]{text-align:center!important}.mat-column-structureOpen[_ngcontent-%COMP%]   .mat-chip-list-wrapper[_ngcontent-%COMP%]{justify-content:center!important}"];
export { styles as styles };
